module.exports = __webpack_public_path__ + "img/prod.9f156c24.jpeg";